import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  OnDestroy,
  OnInit
} from "@angular/core";
import {KeyValueDto, Merchant, MerchantVsSubscriptionControllerService} from "../../@services/gen";
import {AuthService} from '../../@services/auth.service';
import {UserModel} from '../../@models/user.model';
import {LocalstorageService} from '../../@services/localstorage.service';
import {kickCashDrawerz} from "../../@services/utils";
import packageJson from '../../../../package.json';
import {
  PrinterConfigDialogComponent
} from "../../@pages/user-profile/printer-config-dialog/printer-config-dialog.component";
import {take} from "rxjs";
import {TdDialogService} from "@covalent/core/dialogs";
import {FeatureService} from "../../@services/feature.service";

type MerchantWastageCompat = Merchant & {
  wastageConfig?: {
    isAllowWastage?: boolean;
  };
};

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent implements OnInit, OnDestroy {
  merchant: Merchant = {};
  user: UserModel;
  currentTimeIntervalId: number;
  version: string = packageJson.version;
  isMobile: boolean = false;
  isShow: boolean = false;
  isWastageEnabled: boolean = false;

  constructor(private customAuthService: AuthService,
              private ls: LocalstorageService,
              private ds: TdDialogService,
              private fs: FeatureService) {
    this.checkIsMobile();
  }

  ngOnInit(): void {
    this.user = this.customAuthService.getUser();
    this.merchant = this.ls.getMerchant();
    const merchantWithWastage = this.merchant as MerchantWastageCompat;
    this.isWastageEnabled = merchantWithWastage?.wastageConfig?.isAllowWastage === true;
    this.checkPermission();
  }

  ngOnDestroy(): void {
    clearInterval(this.currentTimeIntervalId);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.checkIsMobile();
  }

  private checkIsMobile() {
    this.isMobile = window.innerWidth < 768; // You can adjust the threshold as needed
  }


  kickCashDrawer() {
    kickCashDrawerz();
  }

  reload() {
    window.location.reload();
  }

  checkPermission() {
    if (this.fs.isAllow('S01') || this.merchant.id === 38 || this.merchant.id === 3 || this.merchant.id === 69) {
      this.isShow = true;
    } else {
      this.isShow = false;
    }
  }

  printerConfig() {
    let minHeight = null;
    let minWidth = '50%';

    if (this.isMobile) {
      minHeight = '100vh';
      minWidth = '90%';
    }

    this.ds.open(PrinterConfigDialogComponent, {
        minWidth: minWidth,
      })
      .afterClosed()
      .pipe(take(1))
      .subscribe((data) => {
      });
  }


}
